import { registerGenerator } from '@/utils/generate';
import { KbnConst } from '@/utils/kbn';

import { ContentBase } from './content_base';

export class ContentPurchaseCountConfirmModel extends ContentBase {
  typeKbn = KbnConst.CONTENT_TYPE_KBN_PURCHASE_COUNT_CONFIRM;

  constructor(init?: Partial<ContentPurchaseCountConfirmModel>) {
    super();
    Object.assign(this, init);
  }
}

registerGenerator(
  ContentPurchaseCountConfirmModel,
  () => new ContentPurchaseCountConfirmModel(),
);
